export const translations = {
  en: {
    // Navigation
    tamuService: "Dar Al-Wafa Service System",
    hi: "Hi",
    signOut: "Sign Out",
    back: "Back",
    
    // Home Page
    welcomeMessage: "Welcome to the Dar Al-Wafa Services Platform",
    chooseYourService: "Choose your service",
    viewMenu: "View Menu",
    shopNow: "Shop Now",
    viewProduct: "Daftar Hadiah",
    copyright: "© 2026 Habib Umar's Special Treats House. All rights reserved.",
    createdBy: "Created by Majelis AlMuwasholah Team",
    
    // Login Page
    welcomeBack: "Welcome Back",
    signInToAccess: "Sign in to access your dashboard",
    username: "Username",
    password: "Password",
    enterUsername: "Enter your username",
    enterPassword: "Enter your password",
    signingIn: "Signing in...",
    signIn: "Sign In",
    
    // Admin Dashboard
    adminDashboard: "Admin Dashboard",
    totalUsers: "Total Users",
    products: "Products",
    totalOrders: "Total Orders",
    pending: "Pending",
    recentOrders: "Recent Orders",
    realtimeOrderUpdates: "Real-time order updates",
    noOrdersYet: "No orders yet",
    order: "Order",
    
    // Product Management
    productManagement: "Product Management",
    manageProductCatalog: "Manage your product catalog",
    addProduct: "Add Product",
    editProduct: "Edit Product",
    addNewProduct: "Add New Product",
    productImage: "Product Image",
    productName: "Product Name",
    enterProductName: "Enter product name",
    description: "Description",
    enterProductDescription: "Enter product description",
    stockQuantity: "Stock Quantity",
    updateProduct: "Update Product",
    createProduct: "Create Product",
    cancel: "Cancel",
    available: "Available",
    edit: "Edit",
    noProductsYet: "No products yet",
    addFirstProduct: "Add your first product to get started",
    
    // Image Upload
    chooseImage: "Choose Image",
    uploading: "Uploading...",
    
    // Admin Navigation
    dashboard: "Dashboard",
    orderManagement: "Order Management",
    userManagement: "User Management",
    admin: "Admin",
    
    // User Management
    manageSystemUsers: "Manage system users and their roles",
    refresh: "Refresh",
    addNewUser: "Add New User",
    searchUsers: "Search users by username or role...",
    loadingUsers: "Loading users...",
    noUsersFound: "No users found",
    noUsersMatch: "No users match the current search or there are no users in the system.",
    totalUsers2: "Total users",
    filtered: "Filtered",
    editUser: "Edit User",
    deleteUser: "Delete",
    role: "Role",
    user: "User",
    leaveEmptyPassword: "(leave empty to keep current)",
    areYouSureDelete: "Are you sure you want to delete this user?",
    update: "Update",
    create: "Create",
    
    // Order Management
    manageTrackOrders: "Manage and track all customer orders",
    realtimeUpdates: "Real-time updates",
    searchOrders: "Search orders by ID, status, or items...",
    allOrders: "All Orders",
    completed: "Completed",
    loadingOrders: "Loading orders...",
    noOrdersFound: "No orders found",
    noOrdersMatch: "No orders match the current filter",
    totalOrders2: "Total orders",
    viewItems: "View Items",
    hideItems: "Hide Items",
    orderItems: "Order Items",
    quantity: "Quantity",
    markAsPending: "Mark as Pending",
    markAsCompleted: "Mark as Completed",
    
    // Orders Page
    myOrders: "My Orders",
    backToProducts: "Back to Products",
    orderHistory: "Order History",
    noOrdersYet2: "No orders yet",
    totalItems2: "Total Items",
    
    // Order Status
    permintaanPesanan: "Order Request",
    pesananSelesai: "Order Completed",
    
    // Product Detail
    loading: "Loading...",
    description2: "Description",
    productDetails: "Product Details",
    productId: "Product ID",
    stockAvailable: "Stock Available",
    units: "units",
    added: "Added",
    quantity2: "Quantity",
    
    // Home Page
    addToCart: "Add to Cart",
    outOfStock: "Out of Stock",
    left: "left",
    viewCart: "View Cart",
    
    // Cart Page
    shoppingCart: "Shopping Cart",
    yourCartIsEmpty: "Your cart is empty",
    addSomeProducts: "Add some products to get started",
    startShopping: "Start Shopping",
    totalItems: "Total Items",
    readyToCheckout: "Ready to checkout",
    placeOrder: "Place Order",
    cart: "Cart",
    items: "items",
    
    // Categories
    categories: "Categories",
    manage: "Manage",
    
    // Menu Categories
    menuCategoryManagement: "Menu Category Management",
    menuCategories: "Menu Categories",
    manageMenuCategories: "Manage menu food & drink categories",
    addCategory: "Add Category",
    noCategoriesYet: "No categories yet",
    addFirstCategory: "Add your first category to get started",
    editCategory: "Edit Category",
    addNewCategory: "Add New Category",
    categoryName: "Category Name",
    enterCategoryName: "Enter category name",
    enterCategoryDescription: "Enter category description",
    noDescription: "No description",
    areYouSureDeleteMenuCategory: "Are you sure you want to delete this menu category?",
    
    // Guest Serving Product
    guestServingProduct: "Guest Serving Product",
    guestServingProductManagement: "Guest Serving Product Management",
    manageGuestServingCatalog: "Manage your guest serving product catalog",
    
    // Menu Food & Drink
    menuFoodDrink: "Menu Food & Drink",
    manageRestaurantMenu: "Manage restaurant menu items",
    addMenuItem: "Add Menu Item",
    searchMenuItems: "Search menu items...",
    allCategories: "All Categories",
    food: "Food",
    drink: "Drink",
    snack: "Snack",
    dessert: "Dessert",
    allStatus: "All Status",
    notAvailable: "Not Available",
    showing: "Showing",
    of: "of",
    editMenuItem: "Edit Menu Item",
    addNewMenuItem: "Add New Menu Item",
    itemImage: "Item Image",
    itemName: "Item Name",
    enterItemName: "Enter item name",
    enterItemDescription: "Enter item description",
    category: "Category",
    stockStatus: "Stock Status",
    updateItem: "Update Item",
    createItem: "Create Item",
    markUnavailable: "Mark Unavailable",
    markAvailable: "Mark Available",
    page: "Page",
    noItemsFound: "No items found",
    noMenuItemsYet: "No menu items yet",
    tryAdjustingFilters: "Try adjusting your search or filters",
    addFirstMenuItem: "Add your first menu item to get started",
    areYouSureDeleteMenuItem: "Are you sure you want to delete this menu item?",
    selectCategory: "Select a category",
    noCategory: "No Category",
    
    // Home Page Sections
    menuFoodDrinkSection: "Menu Food & Drink",
    guestServingProductSection: "Guest Serving Product",
    exploreMenu: "Explore our delicious menu",
    shopProducts: "Shop quality products for your guests"
  },
  ar: {
    // Navigation
    tamuService: "نظام خدمات دار الوفاء",
    hi: "مرحبا",
    signOut: "تسجيل الخروج",
    back: "رجوع",
    
    // Home Page
    welcomeMessage: "مرحبا بكم في نظام الخدمات بدار الوفاء",
    chooseYourService: "اختر خدمتك",
    viewMenu: "عرض القائمة",
    shopNow: "تسوق الآن",
    viewProduct: "قائمة الهدايا",
    copyright: "© 2026 بيت حلويات حبيب عمر الخاصة. جميع الحقوق محفوظة.",
    createdBy: "تم التطوير بواسطة فريق مجلس الموصلة",
    
    // Login Page
    welcomeBack: "مرحباً بعودتك",
    signInToAccess: "سجل الدخول للوصول إلى لوحة التحكم",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    enterUsername: "أدخل اسم المستخدم",
    enterPassword: "أدخل كلمة المرور",
    signingIn: "جاري تسجيل الدخول...",
    signIn: "تسجيل الدخول",
    
    // Admin Dashboard
    adminDashboard: "لوحة تحكم المدير",
    totalUsers: "إجمالي المستخدمين",
    products: "المنتجات",
    totalOrders: "إجمالي الطلبات",
    pending: "قيد الانتظار",
    recentOrders: "الطلبات الأخيرة",
    realtimeOrderUpdates: "تحديثات الطلبات المباشرة",
    noOrdersYet: "لا توجد طلبات بعد",
    order: "طلب",
    
    // Product Management
    productManagement: "إدارة المنتجات",
    manageProductCatalog: "إدارة كتالوج المنتجات",
    addProduct: "إضافة منتج",
    editProduct: "تعديل المنتج",
    addNewProduct: "إضافة منتج جديد",
    productImage: "صورة المنتج",
    productName: "اسم المنتج",
    enterProductName: "أدخل اسم المنتج",
    description: "الوصف",
    enterProductDescription: "أدخل وصف المنتج",
    stockQuantity: "كمية المخزون",
    updateProduct: "تحديث المنتج",
    createProduct: "إنشاء المنتج",
    cancel: "إلغاء",
    available: "متوفر",
    edit: "تعديل",
    noProductsYet: "لا توجد منتجات بعد",
    addFirstProduct: "أضف منتجك الأول للبدء",
    
    // Image Upload
    chooseImage: "اختر صورة",
    uploading: "جاري الرفع...",
    
    // Admin Navigation
    dashboard: "لوحة التحكم",
    orderManagement: "إدارة الطلبات",
    userManagement: "إدارة المستخدمين",
    admin: "مدير",
    
    // User Management
    manageSystemUsers: "إدارة مستخدمي النظام وأدوارهم",
    refresh: "تحديث",
    addNewUser: "إضافة مستخدم جديد",
    searchUsers: "ابحث عن المستخدمين بالاسم أو الدور...",
    loadingUsers: "جاري تحميل المستخدمين...",
    noUsersFound: "لم يتم العثور على مستخدمين",
    noUsersMatch: "لا يوجد مستخدمون يطابقون البحث الحالي أو لا يوجد مستخدمون في النظام.",
    totalUsers2: "إجمالي المستخدمين",
    filtered: "مفلتر",
    editUser: "تعديل المستخدم",
    deleteUser: "حذف",
    role: "الدور",
    user: "مستخدم",
    leaveEmptyPassword: "(اترك فارغاً للاحتفاظ بالحالية)",
    areYouSureDelete: "هل أنت متأكد من حذف هذا المستخدم؟",
    update: "تحديث",
    create: "إنشاء",
    
    // Order Management
    manageTrackOrders: "إدارة وتتبع جميع طلبات العملاء",
    realtimeUpdates: "تحديثات مباشرة",
    searchOrders: "ابحث في الطلبات بالرقم أو الحالة أو العناصر...",
    allOrders: "جميع الطلبات",
    completed: "مكتملة",
    loadingOrders: "جاري تحميل الطلبات...",
    noOrdersFound: "لم يتم العثور على طلبات",
    noOrdersMatch: "لا توجد طلبات تطابق الفلتر الحالي",
    totalOrders2: "إجمالي الطلبات",
    viewItems: "عرض العناصر",
    hideItems: "إخفاء العناصر",
    orderItems: "عناصر الطلب",
    quantity: "الكمية",
    markAsPending: "تحديد كقيد الانتظار",
    markAsCompleted: "تحديد كمكتمل",
    
    // Orders Page
    myOrders: "طلباتي",
    backToProducts: "العودة إلى المنتجات",
    orderHistory: "تاريخ الطلبات",
    noOrdersYet2: "لا توجد طلبات بعد",
    totalItems2: "إجمالي العناصر",
    
    // Order Status
    permintaanPesanan: "طلب مقدم",
    pesananSelesai: "طلب مكتمل",
    
    // Product Detail
    loading: "جاري التحميل...",
    description2: "الوصف",
    productDetails: "تفاصيل المنتج",
    productId: "رقم المنتج",
    stockAvailable: "المخزون المتاح",
    units: "وحدة",
    added: "مضاف",
    quantity2: "الكمية",
    
    // Home Page
    addToCart: "أضف إلى السلة",
    outOfStock: "نفد المخزون",
    left: "متبقي",
    viewCart: "عرض السلة",
    
    // Cart Page
    shoppingCart: "سلة التسوق",
    yourCartIsEmpty: "سلة التسوق فارغة",
    addSomeProducts: "أضف بعض المنتجات للبدء",
    startShopping: "ابدأ التسوق",
    totalItems: "إجمالي العناصر",
    readyToCheckout: "جاهز للدفع",
    placeOrder: "تأكيد الطلب",
    cart: "السلة",
    items: "عناصر",
    
    // Categories
    categories: "الفئات",
    manage: "إدارة",
    
    // Menu Categories
    menuCategoryManagement: "إدارة فئات القائمة",
    menuCategories: "فئات القائمة",
    manageMenuCategories: "إدارة فئات الطعام والشراب",
    addCategory: "إضافة فئة",
    noCategoriesYet: "لا توجد فئات بعد",
    addFirstCategory: "أضف فئتك الأولى للبدء",
    editCategory: "تعديل الفئة",
    addNewCategory: "إضافة فئة جديدة",
    categoryName: "اسم الفئة",
    enterCategoryName: "أدخل اسم الفئة",
    enterCategoryDescription: "أدخل وصف الفئة",
    noDescription: "لا يوجد وصف",
    areYouSureDeleteMenuCategory: "هل أنت متأكد من حذف فئة القائمة هذه؟",
    
    // Guest Serving Product
    guestServingProduct: "منتجات خدمة الضيوف",
    guestServingProductManagement: "إدارة منتجات خدمة الضيوف",
    manageGuestServingCatalog: "إدارة كتالوج منتجات خدمة الضيوف",
    
    // Menu Food & Drink
    menuFoodDrink: "قائمة الطعام والشراب",
    manageRestaurantMenu: "إدارة عناصر قائمة المطعم",
    addMenuItem: "إضافة عنصر قائمة",
    searchMenuItems: "ابحث في عناصر القائمة...",
    allCategories: "جميع الفئات",
    food: "طعام",
    drink: "شراب",
    snack: "وجبة خفيفة",
    dessert: "حلوى",
    allStatus: "جميع الحالات",
    notAvailable: "غير متوفر",
    showing: "عرض",
    of: "من",
    editMenuItem: "تعديل عنصر القائمة",
    addNewMenuItem: "إضافة عنصر قائمة جديد",
    itemImage: "صورة العنصر",
    itemName: "اسم العنصر",
    enterItemName: "أدخل اسم العنصر",
    enterItemDescription: "أدخل وصف العنصر",
    category: "الفئة",
    stockStatus: "حالة المخزون",
    updateItem: "تحديث العنصر",
    createItem: "إنشاء العنصر",
    markUnavailable: "تحديد كغير متوفر",
    markAvailable: "تحديد كمتوفر",
    page: "صفحة",
    noItemsFound: "لم يتم العثور على عناصر",
    noMenuItemsYet: "لا توجد عناصر قائمة بعد",
    tryAdjustingFilters: "حاول تعديل البحث أو الفلاتر",
    addFirstMenuItem: "أضف عنصر القائمة الأول للبدء",
    areYouSureDeleteMenuItem: "هل أنت متأكد من حذف عنصر القائمة هذا؟",
    selectCategory: "اختر فئة",
    noCategory: "بدون فئة",
    
    // Home Page Sections
    menuFoodDrinkSection: "قائمة الطعام والشراب",
    guestServingProductSection: "منتجات خدمة الضيوف",
    exploreMenu: "استكشف قائمتنا اللذيذة",
    shopProducts: "تسوق منتجات عالية الجودة لضيوفك"
  }
};

export type Language = 'en' | 'ar';

export const getTranslation = (key: keyof typeof translations.en, language: Language): string => {
  return translations[language][key] || translations.en[key] || key;
};

export const getOrderStatusTranslation = (status: string, language: Language): string => {
  if (status === 'Permintaan Pesanan') {
    return getTranslation('permintaanPesanan', language);
  }
  if (status === 'Pesanan Selesai') {
    return getTranslation('pesananSelesai', language);
  }
  return status;
};
